/**
 * Componente para la  creacion del Do de Importacion
 * @author Henid Herrera <henid.herrera@repremundo.com.co>
 * @since 2025-09-17
 */
import {
  Box,
  Button,
  Flexbox,
  Heading,
  ModalFocus,
  ModalFocusContainer,
  shootToast,
  StepperSimple,
  Stack,
  StackRow,
  Radio,
  Label,
  Divider,
} from "codekit";
import { FormProvider, useForm, Controller } from "react-hook-form";
import {
  useCreateDoImpoMutation,
  useLazyGetGroupByImpoPerfilQuery,
  useGetDataTrackingQuery,
} from "../../../../libs/redux/slices/Modimpxx/Creadoxx/CreadoxxApiSlice";
import { useState, useRef, useEffect, useMemo } from "react";

import Creadop1 from "./Creadop1";
import Creadop2 from "./Creadop2";

const Creadoxx = ({
  handleClose,
  row,
  setShowCreateDo = true,
  modurlxx,
  useAsModal = false,
  stepToShow = 1,
  onSelect,
}) => {
  const methods = useForm({
    mode: "onBlur",
    defaultValues: {
      APLIDOCT: modurlxx === "Doctraxx" ? "SI" : ""
    },
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [filterJson, setFilterJson] = useState({});
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [selectedTransportDocs, setSelectedTransportDocs] = useState([]);
  const [stepper, setStepper] = useState(stepToShow || 1);

  const [createDo, { isLoading }] = useCreateDoImpoMutation();
  const [getGroupByPerfil] = useLazyGetGroupByImpoPerfilQuery();

  const initialrowRef = useRef(null);

  const transportFilters = useMemo(() => {
    const baseFilters = [
      { "DTRCYYYY.REGESTXX": { "IN": ["ACTIVO"] } },
      { "DTRCYYYY.DOCTRAES": { "IN": ["CON SALDO", "COMPLETO"] } }
    ];
    if (row && row.length > 0) {
      const clienteId = row[0].CLIIDXXX;
      if (clienteId) {
        baseFilters.push({ "DTRCYYYY.DTRCNICO": clienteId });
      }
    }

    return baseFilters;
  }, [row]);
  const invoiceFilters = useMemo(() => {
    const filters = [
      { "DSVCYYYY.REGESTXX": { "IN": ["ACTIVO"] } },
      { "DSVCYYYY.SAFAESTX": { "IN": ["CON SALDO", "COMPLETO"] } }
    ];

    if (row && row.length > 0) {
      const r = row[0];

      const clienteId =
        r.CLIIDXXX ??
        r.DTRCNICO ??
        null;

      if (clienteId) {
        filters.push({ "DSVCYYYY.CLIIDXXX": clienteId });
      }
    }

    return filters;
  }, [row]);


  const [rowFilters, setRowFilters] = useState({ transport: [], invoice: [] });


  useEffect(() => {
    if (row && row.length > 0) {
      const transportValues = [];
      const invoiceValues = [];

      row.forEach(item => {
        if (item.DTRCDOTR) {
          transportValues.push(item.DTRCDOTR);
        }
        if (item.FACIDXXX) {
          invoiceValues.push(item.FACIDXXX);
        }
      });

      const newRowFilters = {
        transport: transportValues.length > 0 ? [{ "DTRCYYYY.DTRCDOTR": { "IN": transportValues } }] : [],
        invoice: invoiceValues.length > 0 ? [{ "DSVCYYYY.FACIDXXX": { "IN": invoiceValues } }] : []
      };
      setRowFilters(newRowFilters);
    }
  }, [row]);

  useEffect(() => {
    if (useAsModal && stepToShow) {
      setFilterJson({});
      setStepper(stepToShow);
    }
  }, [useAsModal, stepToShow]);

  const {
    data: dataFacturas,
    isLoading: isLoadingFacturas,
    isFetching: isFetchingFacturas,
  } = useGetDataTrackingQuery(
    {
      page: currentPage,
      per_page: perPage,
      sorts: "-REGFECXX,-REGHORXX",
      MODURLXX: "Faccomxx",
      PRODURLX: "Salfactx",
      filtersJson: JSON.stringify([
        ...invoiceFilters,
        ...rowFilters.invoice,
        filterJson,
      ]),
    },
    { skip: stepper !== 1 }
  );

  const {
    data: dataTransporte,
    isLoading: isLoadingTransporte,
  } = useGetDataTrackingQuery(
    {
      page: currentPage,
      per_page: perPage,
      sorts: "-REGFECXX,-REGHORXX",
      MODURLXX: "Doctraxx",
      PRODURLX: "Saldoctr",
      filtersJson: JSON.stringify([
        ...transportFilters,
        ...rowFilters.transport,
        filterJson,
      ]),
    },
    { skip: stepper !== 2 }
  );

  const {
    handleSubmit,
    formState: { errors },
    watch,
  } = methods;

  useEffect(() => {
    if (initialrowRef.current === null && row) {
      initialrowRef.current = row;
    }
  }, [row]);

  const handleSetStep = (step) => {
    if (useAsModal) return;
    setFilterJson({});
    setStepper(step);
  };

  const onSubmit = async (data) => {
    if (useAsModal) return;
    const copyData = { ...data };
    let docsDTRC = [...selectedTransportDocs];
    let docsDSVC = [...selectedDocs];
    if (docsDTRC && docsDTRC.length > 0) {
      const maxItem = docsDTRC.reduce((prev, current) =>
        Number(current.DTRCVLFB || 0) > Number(prev.DTRCVLFB || 0)
          ? current
          : prev
      );
      copyData.DOCTRIMP = maxItem.DTRCDOTR || "";
      copyData.DEPIDXXX = maxItem.DEPIDXXX || "";
      copyData.DTRCEMTR = maxItem.DTRCEMTR || "";
      copyData.DTRCFCDT = maxItem.DTRCFCDT || "";
      copyData.DTTINUMA = maxItem.DTTINUMA || "";
      copyData.DOCJURAD = maxItem.ODIIDDES !== "" ? maxItem.ODIIDDES : maxItem.DTRCLUIN
      copyData.DOCJURAO = maxItem.ODIIDDES !== "" ? maxItem.ODIIDDES : maxItem.DTRCLUIN
      copyData.MTRIDXXX = maxItem.DTRCMETR || "";
      copyData.DOCMTXXX = maxItem.DTRCMETR || "";
      copyData.DOCDDOEU = maxItem.DTRCAPEU || "";
      copyData.PAIIDPRX = maxItem.DRTCPAPR || "";
      copyData.DTRCYYYY = docsDTRC;
    } else {
      copyData.DTRCYYYY = [];
      copyData.DOCTRIMP = "";
      copyData.DEPIDXXX = "";
      copyData.DTRCEMTR = "";
      copyData.DTRCFCDT = "";
      copyData.DTTINUMA = "";
      copyData.DOCJURAO = "";
    }
    if (docsDSVC && docsDSVC.length > 0) {
      const maxItem = docsDSVC.reduce((prev, current) =>
        Number(current.VALFOBXX || 0) > Number(prev.VALFOBXX || 0)
          ? current
          : prev
      );
      copyData.DOIPEDXX = maxItem.DOIPEDXX || "";
      copyData.IDPROXXX = maxItem.IDPROXXX || "";
      copyData.DSVCYYYY = docsDSVC;
    } else {
      copyData.DSVCYYYY = [];
      copyData.DOIPEDXX = "";
      copyData.IDPROXXX = "";
    }

    try {
      await createDo(copyData)
        .unwrap()
        .then((response) => {
          shootToast({
            variant: "success",
            text: `Se ha creado el DO correctamente con ID ${response.DOCNROXX}.`,
            duration: 5000,
            autoHide: true,
          });
          handleClose();
          setShowCreateDo(false);
        })
        .catch((error) => {
          console.error("Error al crear DO", error);
          shootToast({
            variant: "error",
            text: `Error al crear DO: ${error.data?.mensaje ?? "Ocurrió un error desconocido."
              }`,
            duration: 5000,
            autoHide: true,
          });
        });
    } catch (error) {
      console.error("Error general en el proceso de creación de DO:", error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handlePerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
  };

  const handleFilterChange = (column, value) => {
    if (!value || (typeof value === "string" && value.trim() === "")) {
      setFilterJson({});
      return;
    }

    const finalValue =
      typeof value === "object" && value !== null && "value" in value
        ? value.value
        : value;

    const prefix = stepper === 1 ? "DSVCYYYY" : "DTRCYYYY";

    const dynamicFilter = {
      [`${prefix}.${column}`]: {
        LIKE: [finalValue],
      },
    };
    setFilterJson(dynamicFilter);
    setCurrentPage(1);
  };

  const handleCheckedRows = (checkedRows) => {
    const rows = checkedRows?.rows ?? [];
    setSelectedDocs(rows);

    if (useAsModal && typeof onSelect === "function" && stepper === 1) {
      onSelect(rows);
    }
  };

  const handleCheckedTransportRows = (checkedRows) => {
    const rows = checkedRows?.rows ?? [];
    setSelectedTransportDocs(rows);

    if (useAsModal && typeof onSelect === "function" && stepper === 2) {
      onSelect(rows);
    }
  };

  const validateSameClient = (invoices, transportDocs) => {
    if (useAsModal) return { valid: true };

    if (invoices.length === 0) return { valid: true };
    const firstClientInInvoice = invoices[0]?.CLIIDXXX;
    const allInvoicesSameClient = invoices.every(
      (doc) => doc?.CLIIDXXX === firstClientInInvoice
    );

    if (!allInvoicesSameClient) {
      return {
        valid: false,
        message:
          "Estás seleccionando documentos de diferentes clientes, por favor valide.",
      };
    }
    if (transportDocs.length > 0) {
      const allTransportSameClientAsInvoice = transportDocs.every(
        (doc) => doc?.DTRCNICO === firstClientInInvoice
      );

      if (!allTransportSameClientAsInvoice) {
        return {
          valid: false,
          message:
            "Debe seleccionar facturas y documentos de transporte del mismo cliente, por favor valide.",
        };
      }

      if (transportDocs.length > 1) {
        const areAllZonaFranca = transportDocs.every(
          (row) =>
            row.DEPDESXX &&
            row.DEPDESXX.toLowerCase().includes("zona franca")
        );

        if (!areAllZonaFranca) {
          return {
            valid: false,
            message:
              "Solo puede seleccionar un Documento de Transporte si el depósito no es Zona Franca.",
          };
        }
        const firstDepId = transportDocs[0].DEPIDXXX;
        const allSameDepId = transportDocs.every(
          (row) => row.DEPIDXXX === firstDepId
        );
        if (!allSameDepId) {
          return {
            valid: false,
            message:
              "Los Documentos de transporte no cuentan con el mismo Depósito por favor valide.",
          };
        }
      }
    }
    return { valid: true };
  };

  // Dentro del componente Creadoxx, cerca de los otros useMemo
  const isZonaFranca = useMemo(() => {
    if (selectedTransportDocs.length === 0) return false;

    return selectedTransportDocs.every(
      (row) =>
        row.DEPDESXX &&
        row.DEPDESXX.toLowerCase().includes("zona franca")
    );
  }, [selectedTransportDocs]);


  const handleNextStep = async () => {
    if (useAsModal) return;

    const clientValidation = validateSameClient(selectedDocs, []);

    if (!clientValidation.valid) {
      shootToast({
        variant: "warning",
        text: clientValidation.message,
        duration: 5000,
      });
      return;
    }

    const APLIDOCT = watch("APLIDOCT");
    const clientId = selectedDocs[0]?.CLIIDXXX;
    let groupsData = [];
    if (clientId) {
      try {
        const response = await getGroupByPerfil({ CLIIDXXX: clientId }).unwrap();
        groupsData = response?.data ?? [];
      } catch (error) {
        console.error("Error al obtener grupos de perfil", error);
      }
    }
    const doipedxx = selectedDocs
      .filter((doc) => doc.DOIPEDXX && doc.DOIPEDXX.trim() !== "")
      .map((doc) => doc.DOIPEDXX)
      .join(",");

    const payload = {
      APLIDOCT: "NO",
      DSVCYYYY: selectedDocs,
      CLIIDXXX: clientId,
      USRJEFOG: groupsData[0]?.value ?? "",
      MTRIDXXX: "01",
      DOCJURAD: "03",
      DOCJURAO: "03",
      CCOIDXXX: groupsData[0]?.CCOIDXXX ?? "",
      SUBCCOID: groupsData[0]?.SUBCCOID ?? "",
      DOCTIPXX: "IMPORTACION",
      DOIPEDXX: doipedxx,
    };

    if (APLIDOCT === "NO") {
      onSubmit(payload);
    } else {
      setFilterJson({});
      setStepper(2);
    }
  };

  const handleFinalSubmit = handleSubmit(async (formData) => {
    if (useAsModal) return;

    const clientValidation = validateSameClient(selectedDocs, selectedTransportDocs);

    if (!clientValidation.valid) {
      shootToast({
        variant: 'warning',
        text: clientValidation.message,
        duration: 5000,
      });
      return;
    }
    const clientId = selectedDocs[0]?.CLIIDXXX;
    let groupsData = [];
    if (clientId) {
      try {
        const response = await getGroupByPerfil({ CLIIDXXX: clientId }).unwrap();
        groupsData = response?.data ?? [];
      } catch (error) {
        console.error("Error al obtener grupos de perfil", error);
      }
    }
    const doctrimp = selectedTransportDocs.length > 0
      ? selectedTransportDocs.map(doc => doc.DTRCDOTR).join('-')
      : "";
    const doipedxx = selectedDocs
      .filter(doc => doc.DOIPEDXX && doc.DOIPEDXX.trim() !== '')
      .map(doc => doc.DOIPEDXX)
      .join(',');
    const finalPayload = {
      ...formData,
      DSVCYYYY: selectedDocs,
      DTRCYYYY: selectedTransportDocs,
      CLIIDXXX: clientId,
      USRJEFOG: groupsData[0]?.value ?? "",
      MTRIDXXX: "01",
      DOCJURAD: "03",
      DOCJURAO: "03",
      CCOIDXXX: groupsData[0]?.CCOIDXXX ?? "",
      SUBCCOID: groupsData[0]?.SUBCCOID ?? "",
      DOCTIPXX: "IMPORTACION",
      DOCTRIMP: doctrimp,
      DOIPEDXX: doipedxx,
    };
    onSubmit(finalPayload);
  });

  const APLIUNIF = watch("APLIUNIF");
  const isFinalButtonDisabled =
    selectedTransportDocs.length === 0 || (!APLIUNIF && isZonaFranca);
  const isContinueButtonDisabled =
    selectedDocs.length === 0 ||
    (selectedDocs.length > 0 && !watch("APLIDOCT"));

  if (useAsModal) {
    return (
      <FormProvider {...methods}>
        <Box spacingX={4} spacingY={8} borderTop={0}>
          {stepper === 1 && (
            <ModalFocusContainer>
              <Box mb={2}>
                <Box mt={7} mb={7}>
                  <Divider
                    text="Asociar Documento Soporte Valor"
                    color="accent-600"
                  />
                  <Box mt={7}>
                    {dataFacturas && (
                      <Creadop1
                        data={dataFacturas?.data}
                        meta={dataFacturas?.meta}
                        onPageChange={handlePageChange}
                        onPerPageChange={handlePerPageChange}
                        onFilterChange={handleFilterChange}
                        isLoading={isLoadingFacturas || isFetchingFacturas}
                        handleCheckedRows={handleCheckedRows}
                        checkedRows={selectedDocs}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
            </ModalFocusContainer>
          )}

          {stepper === 2 && (
            <ModalFocusContainer>
              <Box mb={2}>
                <Box mt={7} mb={7}>
                  <Divider
                    text="Asociar Documento de Transporte"
                    color="accent-600"
                  />
                  <Box mt={7}>
                    {dataTransporte && (
                      <Creadop2
                        data={dataTransporte?.data}
                        meta={dataTransporte?.meta}
                        onPageChange={handlePageChange}
                        onPerPageChange={handlePerPageChange}
                        onFilterChange={handleFilterChange}
                        isLoading={isLoadingTransporte}
                        handleCheckedRows={handleCheckedTransportRows}
                        checkedRows={selectedTransportDocs}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
            </ModalFocusContainer>
          )}
        </Box>
      </FormProvider>
    );
  }

  return (
    <ModalFocus isOpen>
      <Box spacing={4} borderBottom={1} borderColor="neutral-300">
        <ModalFocusContainer>
          <Flexbox justifyContent="between">
            <Flexbox justifyContent="start" alignItems="center" gap={4}>
              <Heading variant="heading-6">Nuevo DO de Importacion</Heading>
            </Flexbox>
            <Flexbox justifyContent="end" alignItems="center" gap={4}>
              <Button
                variant="secondary"
                size="2l"
                icon="close"
                onClick={() => {
                  handleClose();
                }}
                minWidth={163}
                onlyIconMobile
                hideIconDesktop
              >
                Cancelar
              </Button>
            </Flexbox>
          </Flexbox>
        </ModalFocusContainer>
      </Box>
      <FormProvider {...methods}>
        <form onSubmit={handleFinalSubmit}>
          <Box spacingX={4} spacingY={8} borderTop={1}>
            <Stack>
              <StepperSimple steps={2} value={stepper} onClick={(step) => handleSetStep(step)} />
            </Stack>
          </Box>
          {stepper === 1 && (
            <ModalFocusContainer>
              <Box mb={2}>
                <Box mt={7} mb={7}>
                  <Divider text="Asociar Documento Soporte Valor" color="accent-600" />
                  <Box mt={7}>
                    {dataFacturas && (
                      <Creadop1
                        data={dataFacturas?.data}
                        meta={dataFacturas?.meta}
                        onPageChange={handlePageChange}
                        onPerPageChange={handlePerPageChange}
                        onFilterChange={handleFilterChange}
                        isLoading={isLoadingFacturas || isFetchingFacturas}
                        handleCheckedRows={handleCheckedRows}
                        checkedRows={selectedDocs}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
              <Box>
                <Stack columnsVariant="form-2">
                  <StackRow>
                    <Label>¿Cuenta con Documento de Transporte?</Label>
                    <Box
                      border={1}
                      spacing={2}
                      rounded="md"
                      borderColor={
                        errors?.APLIDOCT ? "primary-600" : "neutral-300"
                      }
                    >
                      <Flexbox gap={7}>
                        <Flexbox>
                          <Controller
                            control={methods.control}
                            name={`APLIDOCT`}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                              <Radio
                                value={value}
                                checked={value === "SI"}
                                onChange={() => {
                                  onChange("SI");
                                }}
                              >
                                SI
                              </Radio>
                            )}
                          />
                        </Flexbox>
                        <Flexbox>
                          <Controller
                            control={methods.control}
                            name={`APLIDOCT`}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                              <Radio
                                value={value}
                                checked={value === "NO"}
                                onChange={() => {
                                  onChange("NO");
                                }}
                              >
                                NO
                              </Radio>
                            )}
                          />
                        </Flexbox>
                      </Flexbox>
                    </Box>
                  </StackRow>
                </Stack>
              </Box>
            </ModalFocusContainer>
          )}

          {stepper === 2 && (
            <ModalFocusContainer>
              <Box>
                {selectedTransportDocs.length > 0 && isZonaFranca && (
                  <Stack columnsVariant="form-2">
                    <StackRow>
                      <Label>¿Se trata de una operación con unificación de documento de transporte?</Label>
                      <Box
                        border={1}
                        spacing={2}
                        rounded="md"
                        borderColor={
                          errors?.APLIDOCT ? "primary-600" : "neutral-300"
                        }
                      >
                        <Flexbox gap={7}>
                          <Flexbox>
                            <Controller
                              control={methods.control}
                              name={`APLIUNIF`}
                              rules={{ required: true }}
                              render={({ field: { onChange, value } }) => (
                                <Radio
                                  value={value}
                                  checked={value === "SI"}
                                  onChange={() => {
                                    onChange("SI");
                                  }}
                                >
                                  SI
                                </Radio>
                              )}
                            />
                          </Flexbox>
                          <Flexbox>
                            <Controller
                              control={methods.control}
                              name={`APLIUNIF`}
                              rules={{ required: true }}
                              render={({ field: { onChange, value } }) => (
                                <Radio
                                  value={value}
                                  checked={value === "NO"}
                                  onChange={() => {
                                    onChange("NO");
                                  }}
                                >
                                  NO
                                </Radio>
                              )}
                            />
                          </Flexbox>
                        </Flexbox>
                      </Box>
                    </StackRow>
                  </Stack>
                )}
              </Box>
              <Box mb={2}>
                <Box mt={7} mb={7}>
                  <Divider text="Asociar Documento de Transporte" color="accent-600" />
                  <Box mt={7} >
                    {dataTransporte && (
                      <Creadop2
                        data={dataTransporte?.data}
                        meta={dataTransporte?.meta}
                        onPageChange={handlePageChange}
                        onPerPageChange={handlePerPageChange}
                        onFilterChange={handleFilterChange}
                        isLoading={isLoadingTransporte}
                        handleCheckedRows={handleCheckedTransportRows}
                        checkedRows={selectedTransportDocs}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
            </ModalFocusContainer>
          )}

          <Box spacingX={4} spacingY={8} borderTop={1} borderColor="neutral-300">
            <ModalFocusContainer>
              <Flexbox justifyContent="between" alignItems="center" gap={4}>
                <Button
                  type="button"
                  variant="secondary"
                  size="2l"
                  minWidth={200}
                  onClick={stepper === 1 ? () => handleClose() : () => handleSetStep(1)}
                >
                  {stepper === 1 ? "Cancelar" : "Anterior"}
                </Button>
                <Flexbox gap={4}>
                  {stepper === 1 && (
                    <Button
                      type="button"
                      variant="primary-bold"
                      size="2l"
                      minWidth={200}
                      onClick={handleNextStep}
                      disabled={isContinueButtonDisabled}
                    >
                      Continuar
                    </Button>
                  )}
                  {stepper === 2 && (
                    <Button
                      type="submit"
                      variant="primary-bold"
                      size="2l"
                      isLoading={isLoading}
                      disabled={isFinalButtonDisabled}
                      minWidth={200}
                    >
                      Finalizar
                    </Button>
                  )}
                </Flexbox>
              </Flexbox>
            </ModalFocusContainer>
          </Box>
        </form>
      </FormProvider>
    </ModalFocus>
  );
};

export default Creadoxx;
